module.exports = __webpack_public_path__ + "assets/img/rlzp_img.572b51c5.png";